import React from 'react';
import { formatDashboardNumber } from '../../../utils/dashboardV2Utils';

const DashboardV2GlobalCards = ({ cards = {} }) => {
  const el = cards.entreprises_locales || {};
  const hub = cards.entreprises_hubspot || {};
  const dol = cards.dolibarr_clients || {};

  return (
    <div className="row mb-4">
      <div className="col-12 col-md-4 mb-3">
        <div className="card bg-primary-600 v2-global-card">
          <div className="card-body d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-1 fw-bold">{formatDashboardNumber(el.total)}</h4>
              <p className="mb-0">{el.label || 'Entreprises SIRENE (actives)'}</p>
            </div>
            <i className="ri-database-2-line" style={{ fontSize: '2rem' }} />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-4 mb-3">
        <div className="card bg-success-600 v2-global-card">
          <div className="card-body d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-1 fw-bold">{formatDashboardNumber(hub.total)}</h4>
              <p className="mb-0">{hub.label || 'Entreprises Hubspot'}</p>
              <small>{hub.pourcentage ?? 0}% du total</small>
            </div>
            <i className="ri-building-line" style={{ fontSize: '2rem' }} />
          </div>
        </div>
      </div>
      <div className="col-12 col-md-4 mb-3">
        <div className="card bg-info-600 v2-global-card">
          <div className="card-body d-flex justify-content-between align-items-center">
            <div>
              <h4 className="mb-1 fw-bold">{formatDashboardNumber(dol.total)}</h4>
              <p className="mb-0">{dol.label || 'Comptes clients Dolibarr'}</p>
              <small>{dol.pourcentage ?? 0}% du total SIRENE</small>
            </div>
            <i className="ri-pie-chart-line" style={{ fontSize: '2rem' }} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardV2GlobalCards;
